//---------- Dashboard Endpoints ----------//
export const API_GET_DASHBOARD_DATA = "Dashboard";

//---------- Transaction Endpoints ----------//
export const API_GET_DEALER_TRANSACTIONS = "Transaction";
export const API_VOID_TRANSACTION = "Transaction/VoidTransaction";

//---------- Vaulted Card Endpoints ----------//
export const API_VAULTED_CARD = "VaultCard";

//---------- Setting Endpoints ----------//
export const API_ADD_SETTINGS = "EmergePay/DealerEmergePay";
export const API_GET_DEALER_SETTINGS = "EmergePay/GetDealerCredential";

//---------- Users Endpoints ----------//
export const API_GET_USERS = "User/GetDealerUsers";

//---------- Report Endpoints ----------//
export const API_GET_STORE_DEPOSITS = "Report/GetStoreDeposits";
export const API_GET_FORM_TYPES = "Report/GetFormTypes";
export const API_GET_TAX_FORM = "Report/GetTaxForm";

//---------- Surcharge Endpoints ------//
export const API_GET_SURCHARGE_PROFILES =
  "DealerSurcharge/GetSurchargeprofiles";
export const API_GET_DEALER_SURCHARGE_PROFILES =
  "DealerSurcharge/GetAllDealersWithSurchargeProfile";
export const API_GET_DEALER_SURCHARGE_PROFILE_BY_DEALERID =
  "DealerSurcharge/GetDealerWithSurchargeProfile";
export const API_POST_HANDLE_SURCHARGE_FOR_DEALER =
  "DealerSurcharge/HandleSurchargeForDealer";
export const API_GET_SURCHARGE_PROFILES_By_Pagination =
  "DealerSurcharge/GetSurchargeprofilesWithPagination";
export const API_POST_CREATE_SURCHARGE_PROFILE =
  "DealerSurcharge/CreateSurchargeProfile";
export const API_PUT_UPDATE_SURCHARGE_PROFILE =
  "DealerSurcharge/UpdateSurchargeProfile";
export const API_DELETE_SURCHARGE_PROFILE =
  "DealerSurcharge/DeleteSurchargeProfile";

//---------- Everest Query Endpoint ----//
export const API_POST_EVEREST_QUERY = "Everest/query";

//---------- Dealers Endpoint ----//
export const API_POST_ONBOARDED_DEALERS = "Dealer/GetAllOnBoardedDealers";
export const API_GET_ONBOARDED_DEALERS_BY_MERCHANT = "Dealer/GetAllOnboardedDealersByMerchant";

//---------- WNF Endpoints ----//
export const API_GENERIC_WNF_SUBSCRIBERS = "WebHookSubscriber";
export const API_GET_WNF_EVENTS = "WebHookEvents";
export const API_POST_WNF_HEALTH_CHECK_PING = "WebHookHealthCheck/ping";
export const API_POST_CREATE_SECRET = "WebHooksSecret";
export const API_POST_GET_ALL_WEBHOOK_SUBSCRIBERS =
  "WebHookSubscriber/GetAllSubscribers";
export const API_PUT_UPDATE_SUBSCRIBER_STATUS =
  "WebHookSubscriber/UpdateSubscriberStatus";

//---------- Perseuspay Endpoint ----//

//---------- PricingModel Endpoint ----//

export const API_POST_SPLIT_CONFIGURATION_DETAILS =
  "PricingModel/GetAllPricingModelRules";
export const API_POST_SPLIT_CONFIGURATIONS_LIST =
  "PricingModel/GetAllPricingModels";
export const API_POST_SPLIT_CONFIGURATION_DELETE =
  "PricingModel/DeletePricingModel";
export const API_POST_SPLIT_CONFIGURATIONS_MERCHANT_ACCOUNT_LIST =
  "PricingModel/GetMerchantAccounts";
export const API_GET_MERCHANT_PAYMENT_METHOD_LIST =
  "PricingModel/GetMerchantPaymentMethods";
export const API_GET_PRICING_MODEL_DETAILS = "PricingModel/GetDetails";
export const API_POST_SPLIT_CONFIGURATIONS_CREATE =
  "PricingModel/CreatePricingModels";
export const API_POST_SPLIT_CONFIGURATIONS_UPDATE =
  "PricingModel/UpdatePricingModel";

//------ User Preferences Endpoints ------//
export const API_GET_USER_PREFERENCES = "UserPreference/fetch";
export const API_POST_USER_PREFERENCES = "UserPreference/save";

//------ Custom Field Endpoints ------//
export const API_GET_CUSTOM_FIELDS = "CustomField";

//------ Dealer Import Endpoints ------//
export const API_GET_DEALER_IMPORT_TEMPLATE = "Support/DealerImport/Template";
export const API_POST_DEALER_IMPORT_UPLOAD = "Support/DealerImport/Upload";
export const API_GET_DEALER_IMPORT_JOBS = "Support/DealerImport/Jobs";
export const API_GET_DEALER_IMPORT_JOB = (jobId: string) =>
  `Support/DealerImport/Jobs/${jobId}`;
export const API_GET_DEALER_IMPORT_ERRORS = (jobId: string) =>
  `Support/DealerImport/Jobs/${jobId}/Errors.csv`;